<template>
   <!-- 微信代金券 weChatVoucher add-->
  <div>
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @ok="okFun"
      @cancel="closeFun"
      v-bind="this.$store.state.modalConfig"
      width='700px'
    >
      <x-addEdit
        ref="addEdit"
        :itemLayout="$store.state.modal_ItemLayout"
        :formList="formList"
        :formKey="formKey"
        :initReqHandle = 'initReqHandle'
        :isSubmitBtn="false"
      >
      </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '@/utils/mixins';
export default {
  mixins: [fetchSelect],
  components: { },
  data () {
    return {
      initReqHandle: false,
      modalTitle: '新增',
      visible: false,
      formList: [
        {
          label: '代金券批次号',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入微信所分发的代金券批次号',
          props: ['stockId', {
            rules: [{ required: true, message: '请输入微信所分发的代金券批次号' }]
          }]
        }
      ],
      formKey: {
      }
    };
  },
  created () {
  },
  methods: {
    show () {
      this.visible = true;
    },
    okFun () {
      this.$refs.addEdit.form.validateFields((err, values) => {
        if (err) {
          return;
        }
        this.$post({
          url: '/pm/wx/coupon',
          params: {
            ...values
          }
        }).then((res) => {
          this.$message.success('操作成功');
          this.visible = false;
          this.$parent.$refs.table.getTableList();
        });
      });
    },

    closeFun () {
      this.visible = false;
    }
  }
};
</script>
<style lang="less" scoped>
</style>
